import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url: '/merchantShop/getAdminList',
    method: 'get',
    params: params
  })
}

export function getMerchantShopSelectSList(params) {
  return request({
    url: '/merchantShop/getMerchantShopSelectSList',
    method: 'get',
    params: params
  })
}

export function remove(id) {
  return request({
    url: '/merchantShop/remove/' + id,
    method: 'post'
  })
}

export function saveOrUpdate(data) {
  return request({
    url: '/merchantShop/saveOrUpdate',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/merchantShop.js